import React from 'react';

import Header from '../shared/Header';

const NoIslandScreen = (): React.ReactElement => (
  <div className="panel box center">
    <Header variant="h2" title="No islands" />

    <p>
      There are no islands saved in this school.
    </p>

    <p>
      Please ask your teacher to create an island for you.
    </p>
  </div>

);

export default NoIslandScreen;
